<template>
    <div v-for="(v,key) in data" :key="key" class="input-group">
        <label class="label">{{ key }}</label>
        <input v-model="data[key]" type="text" class="input" />
    </div>
  
    
</template>

<script setup>
import {ref, defineEmits,defineProps } from 'vue';
import IconButton from '@/components/IconButton.vue';

const data = defineModel('data');

</script>

<style lang="scss" scoped>

.input-group {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.label {
  font-size: .9rem;
}

.input {
  border: 1px solid grey;
  border-radius: 6px;
  padding: 4px;
  background-color: white;
}
</style>